import { Actions, UseOverlayState } from './types';

export const defaultState = (): UseOverlayState => ({
  showOverlay: true,
});

export const reducers = (state: UseOverlayState, action: Actions): UseOverlayState => {
  switch (action.type) {
    case 'SET_SHOW_OVERLAY':
      return { ...state, showOverlay: action.payload.showOverlay };
  }
};
